// 方案列表配置信息
export default {
  title: '促销活动',
  extraLabel: '可赠总数量:',
  placeholder: '扫描或输入商品编码/条码',
  onSelected: 'checkSelectedPromotion',
  onDetailOk: 'executePromotion',
  onDetailCancel: 'hideMoreButtons',
  onDetailChange: 'checkInventoryProps',
  onSearch: 'searchPromotionGift',
  onCancel: 'cancelPromotion',
  onOk: 'finishPromotion',
  onRowClick: 'checkMoreActions',
  onMoreClick: 'executeMoreAction'
}
